const HOST_API_KEY = process.env.NEXT_PUBLIC_HOST_API_KEY || ""
const APP_ENVIRONMENT = process.env.NEXT_PUBLIC_NODE_ENV
const HOST_FIREBASE_CONFIG = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MESSUREMENT_ID,
}

const SPEEDOFME_ACCOUNT_KEY = process.env.NEXT_PUBLIC_SPEEDOFME_ACCOUNT_KEY
const SPEEDOFME_DOMAIN_NAME = process.env.NODE_ENV === "development" ? "localhost" : process.env.NEXT_PUBLIC_SPEEDOFME_DOMAIN_NAME
const DOWNTIME_MODE = process.env.NEXT_PUBLIC_DOWNTIME_MODE === "true" ? true : process.env.NEXT_PUBLIC_DOWNTIME_MODE === "false" ? false : undefined

export { HOST_API_KEY, APP_ENVIRONMENT, HOST_FIREBASE_CONFIG, SPEEDOFME_ACCOUNT_KEY, SPEEDOFME_DOMAIN_NAME, DOWNTIME_MODE }
